<template>
  <!-- ไม่มีข้อมูล = ไม่กินที่เลย (แพ็กเกจส่วนใหญ่มีคนถือคนเดียว ไม่ต้องอธิบายอะไร) -->
  <div v-if="hasAnything" class="chl">
    <div class="chl-row">
      <span class="chl-label">{{ $t('courseHolders.current') }}</span>
      <span v-if="holderList.length" class="chl-names">
        <span v-for="(s, i) in holderList" :key="s.studentid" class="chl-name">
          {{ s.nickname || s.fullname || s.studentid
          }}<span v-if="s.slot === 'next'" class="chl-slot">{{ $t('courseHolders.nextSlot') }}</span
          ><template v-if="i < holderList.length - 1">, </template>
        </span>
      </span>
      <span v-else class="chl-empty">{{ $t('courseHolders.none') }}</span>

      <span v-if="holderList.length > 1" class="chl-count" :class="{ 'chl-count-warn': holderList.length >= 3 }">
        {{ $t('courseHolders.shareCount', { count: holderList.length }) }}
        <template v-if="families > 1"> · {{ $t('courseHolders.familyCount', { count: families }) }}</template>
      </span>
    </div>

    <!-- แถวที่สองโผล่เฉพาะเมื่อมีคนที่เคยใช้แต่ไม่ได้ถือแล้วจริง ๆ -->
    <div v-if="releasedList.length" class="chl-row chl-row-past">
      <span class="chl-label">{{ $t('courseHolders.past') }}</span>
      <span class="chl-names">
        <span v-for="(s, i) in releasedList" :key="s.studentid" class="chl-name">
          {{ s.nickname || s.fullname || s.studentid
          }}<template v-if="i < releasedList.length - 1">, </template>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
/**
 * บรรทัด "ใครใช้แพ็กเกจคอร์สนี้" — ใช้ร่วมกัน 3 จอ (คอร์สลูกค้า / ประวัติคอร์ส / รายชื่อนักเรียน)
 * ทั้งสามจอเคยเขียนข้อความนี้เองด้วย $t('customerCourse.courseInUseBy') คนละชุด
 *
 * รับข้อมูลจาก /getStudentCourseDetail ตรง ๆ (บล็อก holders / everUsed) — ไม่ยิง API เอง
 * เพราะพ่อแม่ทั้งสามจอโหลดข้อมูลก่อนเปิด dialog อยู่แล้วตามกติกา "เปิด dialog เมื่อข้อมูลครบ"
 *
 * แยกสองบรรทัดโดยตั้งใจ: "ถืออยู่ตอนนี้" กับ "เคยใช้" เป็นคนละคำถาม — owner ไม่ลบชื่อคนที่
 * ถอดคอร์สออกไปแล้ว การรวมสองอย่างเป็นบรรทัดเดียวจึงทำให้แอดมินอ่านว่ามีคนใช้มากกว่าจริง
 */
export default {
  name: 'CourseHoldersLine',
  props: {
    holders: { type: Object, default: null },   // { count, families, students[] }
    everUsed: { type: Object, default: null },  // { count, students[{..., released}] }
  },
  computed: {
    holderList() {
      return (this.holders && this.holders.students) || [];
    },
    families() {
      return (this.holders && this.holders.families) || 0;
    },
    releasedList() {
      const all = (this.everUsed && this.everUsed.students) || [];
      return all.filter((s) => s.released === 1 || s.released === true);
    },
    hasAnything() {
      return this.holderList.length > 0 || this.releasedList.length > 0;
    },
  },
};
</script>

<style scoped>
.chl {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 6px;
}
.chl-row {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 8px;
  font-size: 12.5px;
  line-height: 1.5;
}
.chl-label {
  color: var(--c-text-muted);
  flex: 0 0 auto;
}
.chl-names {
  color: var(--c-text-body);
}
.chl-name {
  white-space: nowrap;
}
/* ป้าย (คอร์สถัดไป) — ข้อมูลที่ไม่เคยมีที่ไหนมาก่อน จึงต้องอ่านออกทันทีว่าต่างจากคนอื่น */
.chl-slot {
  color: var(--c-text-muted);
  font-size: 11.5px;
  margin-left: 3px;
}
.chl-empty {
  color: var(--c-text-muted);
}
.chl-count {
  color: var(--c-text-muted);
  white-space: nowrap;
}
/* 3 คนขึ้นไป = ใกล้เพดาน 4 คน และเป็นเคสที่หายากมากบน prod — ให้สะดุดตาแต่ไม่ตกใจ */
.chl-count-warn {
  color: var(--c-warning);
  font-weight: 600;
}
.chl-row-past .chl-names {
  color: var(--c-text-muted);
}
</style>
